import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import { withSnackbar } from "notistack";
import withStyles from "@material-ui/core/styles/withStyles";
import { connect } from "react-redux";
import { ErrorMessages } from "Constants";
import { bindActionCreators } from "redux";
import { checkboxinputconverter } from "Component/DynamicForm/Fields/CheckBox";
// import infoIcon from "Assets/newicons/notify/info/outline/info-outline-16px.svg";
import infoIcon from "Assets/Icons/Info/info-16px.svg";
import elephant from "Assets/Svg/elephant.svg";
import Tooltip from "@material-ui/core/Tooltip";
import pointingHandIcon from "Assets/Svg/hand-pointing-right.svg";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";
import ProfilePicture from "Component/Thumbnail/ProfilePicture";
import { getFormattedImageLink } from "Utils";
import DynamicForm from "../../../../../../Component/DynamicForm";
import { instance } from "../../../../../../Actions/AxiosInstance";

const styles = () => ({
  customWidth: {
    maxWidth: 300,
    height: "auto",
    maxHeight: "200px !important",
  },
});

const feedbacksettings = [
  {
    displayname: "Show names",
    displayvalue: false,
  },
  {
    displayname: "Make anonymous",
    displayvalue: true,
  },
];

const permissionsettings = [
  {
    displayname: "Give permission",
    displayvalue: true,
  },
  {
    displayname: "Deny permission",
    displayvalue: false,
  },
];
class deliverables extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedReview: props.selectedReview,
      // feedbacksettingsid: 1,
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.props.onRef({
      onNext: this.onSubmit,
    });
  }

  handleChange(key, value, participanttypeid) {
    const { selectedReview } = this.state;
    if (key == "isviewduring") {
      selectedReview.participant[participanttypeid - 1][key] = value;
      selectedReview.participant[participanttypeid - 1].isviewafter = value;
    } else {
      selectedReview.participant[participanttypeid - 1][key] = value;
    }
    this.setState({
      selectedReview,
    });
  }

  // handleChange1(key, value, participanttypeid) {
  //   const { selectedReview } = this.state;
  //   console.log('value: ', value);
  //   selectedReview.participant[participanttypeid - 1]["isfeedbackanonymous"] = value == 2 ? true : false;
  //   selectedReview.participant[participanttypeid - 1][key] = value;
  //   this.setState({
  //     [key]: value,
  //     selectedReview,
  //   });
  // }

  onSubmit = () => {
    const { selectedReview } = this.state;
    selectedReview.isdraft = false;
    const structure = selectedReview;
    const temostructure = JSON.stringify(selectedReview);
    let selectedData = selectedReview.participant.filter(
      (x) => x.isSelected == true,
    );
    console.log("selectedData: ", selectedData);

    const isCheck = selectedData.map((x) => {
      if (x.openday == null) {
        return false;
      }
      if (x.isfeedbackanonymous == null) {
        return false;
      }
      if (x.isviewduring == null) {
        return false;
      }
      if (x.closeday == null) {
        return false;
      }
      if (selectedReview.reviewperiodtypeid != 1 && x.frequencytypeid == null) {
        return false;
      }
      return true;
    });
    if (isCheck == false) {
      this.props.enqueueSnackbar("Please fill the data", { variant: "error" });
    } else {
      selectedData = selectedData.map((item) => {
        delete item.isSelected;
        return item;
      });
      structure.participant = selectedData;
      instance
        .post("perform/createreviewstructure", structure)
        .then(() => {
          this.props.enqueueSnackbar(ErrorMessages.E0000, {
            variant: "success",
          });
          this.props.onClosed();

          // this.props.getReviewStructure();
          this.setState({
            selectedReview: null,
          });
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
            this.setState({
              selectedReview: JSON.parse(temostructure),
            }),
          );
        });
    }
  };

  render() {
    const { participant } = this.state.selectedReview;
    const { classes } = this.props;
    return (
      <div className="">
        <Grid container>
          <Grid item xs={12} md={8} sm={12}>
            {participant[1].isSelected ||
            participant[2].isSelected ||
            participant[3].isSelected ? (
              <p className="normal-dark margin-bottom-8 display-flex">
                <img className="margin-right-16" src={pointingHandIcon}></img>{" "}
                Configure privacy settings for feedback
              </p>
            ) : (
              <p className="normal-dark-secondary margin-bottom-8">
                No deliverables in this review structure, employee's self review
                will be visible to them by default.
              </p>
            )}
            {participant[1].isSelected ? (
              <div style={{ width: 350 }}>
                {/* <DynamicForm
                  fields={checkboxinputconverter({
                    value: participant[1].isfeedbackanonymous,
                    placeholder: "",
                    label: "Make manager's feedback anonymous",
                  })}
                  onChange={(value) => {
                    this.handleChange("isfeedbackanonymous", value, 2);
                  }}
                /> */}

                <DynamicForm
                  fields={selectinputconverter({
                    value: participant[1].isfeedbackanonymous,
                    placeholder: "Select",
                    label: "Manager’s feedback",
                    options: feedbacksettings,
                  })}
                  onChange={(selectedid) => {
                    this.handleChange("isfeedbackanonymous", selectedid, 2);
                  }}
                />
                <div
                  style={{
                    width: 316,
                    marginBottom: 16,
                    padding: 16,
                    borderRadius: 4,
                    border: "solid 1px #d9dadb",
                    backgroundColor: "#f9f9f9",
                    display: "flex",
                  }}
                >
                  <ProfilePicture
                    src={
                      participant[1].isfeedbackanonymous
                        ? elephant
                        : getFormattedImageLink(this.state.imagepath)
                    }
                    height="32"
                  />
                  {participant[1].isfeedbackanonymous ? (
                    <p className="small-dark-secondary margin-left-16">
                      Elly Elephant gave you 1 out of 5 stars on Communication
                    </p>
                  ) : (
                    <p className="small-dark-secondary margin-left-16">
                      Susan Paige gave you 1 out of 5 stars on Communication
                    </p>
                  )}
                </div>
              </div>
            ) : (
              ``
            )}

            {participant[2].isSelected ? (
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ width: 350 }}>
                  {/* <DynamicForm
                    fields={checkboxinputconverter({
                      value: participant[2].isfeedbackanonymous,
                      placeholder: "",
                      label: "Make upward feedback anonymous",
                    })}
                    onChange={(value) => {
                      this.handleChange("isfeedbackanonymous", value, 3);
                    }}
                  />
                </div>
                <Tooltip
                  classes={{
                    tooltip: classes.customWidth,
                  }}
                  placement="right"
                  title="Upward means managers who above an employee in the company's hierarchy."
                >
                  <div>
                    <i
                      className="material-icons cursor-pointer"
                      style={{ color: "#ddd", cursor: "default" }}
                    >
                      info
                    </i>
                  </div>
                </Tooltip> */}
                  <DynamicForm
                    fields={selectinputconverter({
                      value: participant[2].isfeedbackanonymous,
                      placeholder: "Select",
                      label: "Upward feedback",
                      options: feedbacksettings,
                    })}
                    onChange={(selectedid) => {
                      this.handleChange("isfeedbackanonymous", selectedid, 3);
                    }}
                  />
                  <div
                    style={{
                      width: 316,
                      marginBottom: 16,
                      padding: 16,
                      borderRadius: 4,
                      border: "solid 1px #d9dadb",
                      backgroundColor: "#f9f9f9",
                      display: "flex",
                    }}
                  >
                    <ProfilePicture
                      src={
                        participant[2].isfeedbackanonymous
                          ? elephant
                          : getFormattedImageLink(this.state.imagepath)
                      }
                      height="32"
                    />
                    {participant[2].isfeedbackanonymous ? (
                      <p className="small-dark-secondary margin-left-16">
                        Elly Elephant gave you 1 out of 5 stars on Communication
                      </p>
                    ) : (
                      <p className="small-dark-secondary margin-left-16">
                        Susan Paige gave you 1 out of 5 stars on Communication
                      </p>
                    )}
                  </div>
                </div>
                <div
                  className="helping-hand-wrapper margin-left-16"
                  style={{ padding: 16, width: 258, height: 68 }}
                >
                  <p className="helping-hand-text text-center margin-bottom-16">
                    Helping Hand 👋
                  </p>
                  <p className="small-dark">
                    Upward refers to managers above the employee in company
                    hierarchy
                  </p>
                </div>
              </div>
            ) : (
              ``
            )}
            {participant[3].isSelected ? (
              <div style={{ width: 350 }}>
                {/* <DynamicForm
                  fields={checkboxinputconverter({
                    value: participant[3].isfeedbackanonymous,
                    placeholder: "",
                    label: "Make peer reviewer's feedback anonymous",
                  })}
                  onChange={(value) => {
                    this.handleChange("isfeedbackanonymous", value, 4);
                  }}
                /> */}
                <DynamicForm
                  fields={selectinputconverter({
                    value: participant[3].isfeedbackanonymous,
                    placeholder: "Select",
                    label: "Co-worker's feedback",
                    options: feedbacksettings,
                  })}
                  onChange={(selectedid) => {
                    this.handleChange("isfeedbackanonymous", selectedid, 4);
                  }}
                />
                <div
                  style={{
                    width: 316,
                    marginBottom: 16,
                    padding: 16,
                    borderRadius: 4,
                    border: "solid 1px #d9dadb",
                    backgroundColor: "#f9f9f9",
                    display: "flex",
                  }}
                >
                  <ProfilePicture
                    src={
                      participant[3].isfeedbackanonymous
                        ? elephant
                        : getFormattedImageLink(this.state.imagepath)
                    }
                    height="32"
                  />
                  {participant[3].isfeedbackanonymous ? (
                    <p className="small-dark-secondary margin-left-16">
                      Elly Elephant gave you 1 out of 5 stars on Communication
                    </p>
                  ) : (
                    <p className="small-dark-secondary margin-left-16">
                      Susan Paige gave you 1 out of 5 stars on Communication
                    </p>
                  )}
                </div>
              </div>
            ) : (
              ` `
            )}
          </Grid>
        </Grid>
        <Grid item xs={12} md={8} sm={12}>
          {participant[1].isSelected ||
          participant[2].isSelected ||
          participant[3].isSelected ? (
            <div>
              <p className="normal-dark margin-bottom-8 display-flex">
                <img className="margin-right-16" src={pointingHandIcon}></img>{" "}
                Set permission to view employee’s self review
              </p>
              <p className="small-dark-secondary margin-bottom-16">
                Review will be visible during and after the review period
              </p>
            </div>
          ) : (
            ""
          )}

          {participant[1].isSelected ? (
            <div style={{ width: 350 }}>
              {/* <DynamicForm
                fields={checkboxinputconverter({
                  value: participant[1].isviewduring,
                  placeholder: "",
                  label: "Manager",
                })}
                onChange={(value) => {
                  this.handleChange("isviewduring", value, 2);
                }}
              /> */}
              <DynamicForm
                fields={selectinputconverter({
                  value: participant[1].isviewduring,
                  placeholder: "Select",
                  label: "Manager",
                  options: permissionsettings,
                })}
                onChange={(selectedid) => {
                  this.handleChange("isviewduring", selectedid, 2);
                }}
              />
            </div>
          ) : (
            ``
          )}
          {participant[2].isSelected ? (
            <div style={{ display: "flex", flexDirection: "row", width: 350 }}>
              {/* <DynamicForm
                fields={checkboxinputconverter({
                  value: participant[2].isviewduring,
                  placeholder: "",
                  label: "upward",
                })}
                onChange={(value) => {
                  this.handleChange("isviewduring", value, 3);
                }}
              /> */}
              <DynamicForm
                fields={selectinputconverter({
                  value: participant[2].isviewduring,
                  placeholder: "Select",
                  label: "Upward employees",
                  options: permissionsettings,
                })}
                onChange={(selectedid) => {
                  this.handleChange("isviewduring", selectedid, 3);
                }}
              />
            </div>
          ) : (
            ``
          )}

          {participant[3].isSelected ? (
            <div style={{ width: 350 }}>
              {/* <DynamicForm
                fields={checkboxinputconverter({
                  value: participant[3].isviewduring,
                  placeholder: "",
                  label: "Peer",
                })}
                onChange={(value) => {
                  this.handleChange("isviewduring", value, 4);
                }}
              /> */}
              <DynamicForm
                fields={selectinputconverter({
                  value: participant[3].isviewduring,
                  placeholder: "Select",
                  label: "Co-worker",
                  options: permissionsettings,
                })}
                onChange={(selectedid) => {
                  this.handleChange("isviewduring", selectedid, 4);
                }}
              />
            </div>
          ) : (
            ` `
          )}
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  DynamicForm: state.dynamicformReducer,
  Language: state.LanguageAction.Language,
  holidayPlanReducer: state.holidayPlanReducer,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(deliverables)));
